import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import { useAuth } from "../context/AuthContext";
import { toast } from "../lib/toast";

function FacebookAuthCallback() {
  const navigate = useNavigate();
  const { completeAuthSession } = useAuth();
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const finishFacebookLogin = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const error = params.get("error");

      if (error) {
        toast.error("Facebook login was cancelled or denied.");
        navigate("/login", { replace: true });
        return;
      }

      if (!code) {
        toast.error("Facebook login did not return an authorization code.");
        navigate("/login", { replace: true });
        return;
      }

      try {
        const res = await axiosInstance.post(
          "/api/auth/facebook/",
          { code },
          { _skipGlobalErrorToast: true }
        );

        if (!res.data?.access || !res.data?.refresh) {
          throw new Error("Missing JWT tokens from Facebook login response.");
        }

        await completeAuthSession(res.data);
        toast.success("Logged in with Facebook.");
        navigate("/recipes", { replace: true });
      } catch (err) {
        console.error("Facebook login failed:", err);
        toast.error("Facebook login failed. Please try again.");
        navigate("/login", { replace: true });
      }
    };

    finishFacebookLogin();
  }, [completeAuthSession, navigate]);

  return (
    <div className="min-h-screen bg-[#eef4ff] flex items-center justify-center px-6">
      <div className="rounded-3xl border border-white/80 bg-white/90 px-8 py-10 text-center shadow-[0_30px_80px_-30px_rgba(24,119,242,0.35)] backdrop-blur">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-blue-100 border-t-[#1877f2]" />
        <h1 className="type-section-title mt-5">Signing you in with Facebook</h1>
        <p className="type-muted mt-2">Hang tight while we finish the secure sign-in flow.</p>
      </div>
    </div>
  );
}

export default FacebookAuthCallback;
